import React from 'react'
import HideOnScroll from '../util/hideOnScroll'
import { AppBar, Box, styled } from '@mui/material'
import CartHeader from '../features/cart/components/CartHeader'
import { APPBAR_HEIGHT } from '../util/consts'
import { colors } from '../themes/colors'

const MobileCartAppbar = styled(AppBar)(({ theme }) => ({
  height: `calc(${APPBAR_HEIGHT.sm}px + var(--safe-area-statusbarHeight))`,
  background: colors.primary50,
  boxShadow: '0px 6px 12px 0px rgba(0, 0, 0, 0.10)',
  ...theme.mixins.pagePadding,
  paddingTop: 'var(--safe-area-statusbarHeight) !important',
  paddingBottom: '0px !important',
  display: 'flex',
  justifyContent: 'center',
}))

export const MobileHeader = () => {
  return (
    <HideOnScroll threshold={0}>
      <MobileCartAppbar>
        <Box>
          <CartHeader />
        </Box>
      </MobileCartAppbar>
    </HideOnScroll>
  )
}
